import React from "react";
import useSchool from "../../modules/game/hooks/use-school";
//@ts-ignore
import * as sanitizeHtml from 'sanitize-html';
import './style.scss';

type Props = {
    schoolId: SchoolId,
    onSelected: (id: SchoolId) => void,
    onClose?: () => void
}

const AnswerPanel: React.FunctionComponent<Props> = ({ schoolId, onSelected, onClose }) => {
    const { school } = useSchool(schoolId);

    return (
        <div className="answer-panel">
            <div className="page-container">
                {onClose && <div className="close" onClick={onClose}></div>}
                {school && <>
                    <h2>{school.name}</h2>
                    <div className={`row image-list image-count-${school.image.length}`}>
                        {
                            school.image.map((image, index) => {
                                return (<img key={index} src={process.env.PUBLIC_URL + image.src} alt="" />)
                            })
                        }
                    </div>
                    <div className="description" dangerouslySetInnerHTML={{ __html: sanitizeHtml(school.description) }}></div>

                    <div className="row button-container">
                        <button onClick={() => onSelected(school.id)}>To ta szkoła!</button>

                    </div>
                </>}
            </div>
        </div>
    )
}

export default AnswerPanel;
